import BusinessContext from "context/BusinessContext";
import { useContext } from "react";
import Footer2 from "./Footer2";

export default function Layout2({ children }) {
  return (
    <div>
      {children}
      <Footer2 />
    </div>
  );
}
